"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateName = exports.validatePeoplesoftId = exports.validateMobileNumber = exports.validateCode = exports.validatePassword = exports.validateEmail = exports.emailRegex = void 0;
exports.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
exports.validateEmail = function (email) {
    return exports.emailRegex.test(email);
};
exports.validatePassword = function (password) {
    var passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
    return passwordRegex.test(password);
};
exports.validateCode = function (code) {
    var codeRegex = /^[0-9]{6}$/;
    return codeRegex.test(code);
};
exports.validateMobileNumber = function (mobileNumber) {
    var mobileNumberRegex = /^[0-9+]{11}$/;
    return mobileNumberRegex.test(mobileNumber);
};
exports.validatePeoplesoftId = function (id) {
    var peoplesoftIdRegex = /^[0-9]{6}$/;
    return peoplesoftIdRegex.test(id);
};
exports.validateName = function (name) {
    var lastNameRegex = /^[A-Za-z]/;
    return lastNameRegex.test(name);
};
//# sourceMappingURL=validation.js.map